import { Modal, ModalProps } from 'antd';
import { useState } from 'react';
import { FormInstance } from 'antd/es/form/Form';
import { StockCorrectionFormValues } from '@/core/domain/stock/StockCorrections/StockCorrections.types';
import StockCorrectionSelectItem from './StockCorrectionSelectItem';
import { StockItem } from '@/core/domain/stock/StockItems/StockItems.types';

interface Props extends ModalProps {
  companyId?: number;
  open: boolean;
  onCancel: VoidFunction;
  selectedItems?: StockItem[];
  form: FormInstance<StockCorrectionFormValues>;
}

const StockCorrectionCreateModal = ({
  form,
  companyId,
  selectedItems,
  ...props
}: Props) => {
  const [selectedStockItems, setSelectedStockItems] = useState<StockItem[]>([]);

  async function onSubmit() {
    try {
      if (selectedItems) {
        const fullArray = [...(selectedItems || []), ...selectedStockItems];

        const filteredArray = fullArray.reduce((acc, item) => {
          const hasItem = acc.some(
            (accItem) =>
              (item.partId !== null && accItem.partId === item.partId) ||
              (item.consumableId !== null &&
                accItem.consumableId === item.consumableId),
          );
          if (!hasItem) {
            return [...acc, item];
          }
          return acc;
        }, [] as StockItem[]);

        form.setFieldValue('items', filteredArray);
      }

      setSelectedStockItems([]);
      props.onCancel();
    } catch {}
  }

  async function onClose() {
    props.onCancel();
  }

  return (
    <Modal
      {...props}
      title="Adicionar Item"
      width={'100%'}
      destroyOnClose
      onOk={onSubmit}
      onCancel={onClose}
      okText="Salvar"
    >
      <StockCorrectionSelectItem
        open={props.open}
        companyId={companyId}
        selectedItems={selectedItems}
        selectedStockItems={selectedStockItems}
        setSelectedStockItems={setSelectedStockItems}
      />
    </Modal>
  );
};

export default StockCorrectionCreateModal;
